import { AsyncPipe } from '@angular/common';
import { Component, inject, OnInit } from '@angular/core';
import { LayoutComponent } from '@plantefeve/common/layout/components/layout/layout.component';
import { EnumService } from '@plantefeve/common/services/enum.service';
import { NavigationsService } from '../navigations/services/navigations.service';

@Component({
  selector: 'igx-root',
  imports: [LayoutComponent, AsyncPipe],
  template: `<igx-layout [menu]="(menuItems$ | async) || []"></igx-layout>`,
})
export class RootComponent implements OnInit {
  private readonly _navigationsService = inject(NavigationsService);
  private readonly _enumService = inject(EnumService);

  public menuItems$ = this._navigationsService.getNavigation();
  public ngOnInit(): void {
    this._enumService.initializeEnums();
  }
}
